import { c as _c } from "react/compiler-runtime";
import type { INotificationIdentitySubscribed } from "@/types/feed.types";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
export default function NotificationIdentitySubscribed(t0) {
  const $ = _c(9);
  const {
    notification
  } = t0;
  let t1;
  if ($[0] !== notification.related_identity) {
    t1 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[0] = notification.related_identity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">started following you</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== notification.created_at) {
    t3 = <NotificationTimestamp createdAt={notification.created_at} />;
    $[3] = notification.created_at;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== notification.related_identity || $[6] !== t1 || $[7] !== t3) {
    t4 = <div className="tw-w-full"><NotificationHeader author={notification.related_identity} actions={t1}>{t2}{t3}</NotificationHeader></div>;
    $[5] = notification.related_identity;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}